import { CreditCardStatus } from "./CreditCard";

import OfferCard from "./OfferCard";

import UserRegistrationData from "./UserRegistrationData";

import OfferPage from "types/OfferPage";

export enum Status {
  active = "active",
  pendingActivation = "pendingActivation",
  purchasableExternally = "purchasableExternally",
  purchasable = "purchasable",
  notPurchasable = "notPurchasable",
  cancelled = "cancelled",
  provisioning = "provisioning",
  cardExpired = "cardExpired",
  cardPending = "cardPending",
}

type Offer = {
  cardPaymentId?: string;
  logoImage: string;
  type: string;
  alreadyStandalone?: boolean;
  bundlingFlow: boolean;
  comment?: string;
  emailOtp?: boolean;
  heading?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  links?: any;
  chargingMethod?: "NON_RECURRING" | "RECURRING";
  duration?: {
    name: "WEEKLY" | "MONTHLY" | "QUARTERLY";
    code: number;
    months: number;
    days: number;
  };
  multiPlanOffer?: boolean;
  marketplaceInfo: {
    deepLink: string;
    logoName: string;
    status: Status;
    price: string;
    requireRegForm?: boolean;
    isStartingPrice?: boolean;
    trialInfo?: { amount: number; unit: string; trialPrice: number };
    title: string;
    tag: string;
    customTag: string;
    plan?: {
      streams: number;
      quality: string;
      downloads: string;
    };
    priceText?: string | undefined;
    tncs?: { description: string; size: string };
    bookingDetails?: { title: string; details: string };
    privacy?: { description: string };
    type?: "standalone" | "hardbundle";
    pages: { [key: string]: OfferPage };
    cards: { [key: string]: OfferCard };
    details?: string;
    agency?: boolean;
    revokeDowngradable?: boolean;
    canBeSwitchTo?: canBeSwitchTo[];
    notEligible?: Record<
      NotEligibleState,
      { heading: string; details: string; hasGoogleButton?: boolean; isModal?: boolean }
    >;
    banner?: {
      action: { type: string; label: string };
      carousel: boolean;
      description: string;
      order: number;
      title: string;
      isVideo?: boolean;
    };
    paymentConfirmationBox?: string;
    discountOfferText?: string;
  };
  name: string;
  opco: string;
  packageId: string;
  longPackageId?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  pages?: any;
  partner: string;
  sameCustomer?: boolean;
  switchable?: boolean;
  upgradable?: boolean;
  downgradable?: boolean;
  trial?: boolean;
  version?: number;
  endDate?: Date | string | null;
  startDate?: Date | string | null;
  reactivable?: boolean;
  cancellable?: boolean;
  cancelled?: boolean;
  setupUrl?: string;
  images?: Images;
  recurring: boolean;
  migratedCustomer: boolean;
  status: Status;
  fromPurchasedArray?: boolean;
  campaign?: string;
  externalPayment?: {
    cardStatus: CreditCardStatus;
    externalPaymentId: string;
    cardLastDigits: string;
  };
  price?: number;
  pricingText1?: string;
  pricingText2?: string;
  subscriptionId?: string;
  usergroup?: string;
  userData?: UserRegistrationData;
};

type Images = {
  logo: string;
  logoLandscape: string;
  logoWhite: string;
  logoLandscapeWhite: string;
  card: {
    desktop: string;
    tablet: string;
    mobile: string;
  };
  carousel: {
    baseUrl: string;
  };
  cross: {
    desktop: string;
    tablet: string;
    mobile: string;
  };
  banner: {
    desktop: string;
    tablet: string;
    mobile: string;
  };
};

type canBeSwitchTo = {
  buttonLabel: string;
  buttonType: string;
  order: number;
  offerName: string;
};

export type NotEligibleState =
  | "not_eligible_for_trial"
  | "account_already_exist"
  | "access_denied"
  | "youtube_partner_error";

export default Offer;
